// extracted by mini-css-extract-plugin
export default {"yellowbackground":"jobs_yellowbackground__KjBNA","boldfont":"jobs_boldfont__baXn0","deletebutton":"jobs_deletebutton__kyJb0"};